const ImageTiles = {
  parts: [
    'container',
    'containerInner',
    'headerSection',
    'title',
    'descriptionWrapper',
    'description',
    'tilesGrid',
    'tileCard',
    'imageContainer',
    'image',
    'buttonWrapper',
    'button',
    'buttonIcon',
    'tileTitle'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      bg: 'brandColors.secondaryBG', // #F1EDE4 - Linen 02
      position: 'relative',
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
      py: {base: 15, md: 30}, // 60px mobile, 120px desktop
      px: {base: 5, md: 20}, // 20px mobile, 80px desktop
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 10, md: 16}, // 40px mobile, 64px desktop
    },
    headerSection: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: {base: 4, md: 10}, // 16px mobile, 40px desktop
      alignSelf: 'stretch',
      flexDirection: {base: 'column', md: 'row'},
    },
    title: {
      flex: {base: 'none', md: '1 0 0'},
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'}, // 28px mobile, 40px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%', // 33.6px mobile, 48px desktop
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      mb: 0,
    },
    descriptionWrapper: {
      display: 'flex',
      width: {base: 'full', md: 'calc(50% - 20px)'},
      minWidth: {base: 'auto', md: 'calc(50% - 20px)'},
      pt: {base: 0, md: 2}, // 8px desktop
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 6, // 24px
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg'}, // 16px mobile, 18px desktop
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '160%', // 25.6px mobile, 28.8px desktop
    },
    tilesGrid: {
      columns: {base: 2, md: 4}, // 2 columns mobile, 4 desktop
      spacing: {base: 4.5, md: 10}, // 18px mobile, 40px desktop
      width: 'full',
      alignItems: 'flex-start',
    },
    tileCard: {
      display: 'flex',
      width: 'full',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 3, md: 5}, // 12px mobile, 20px desktop
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flexShrink: 0,
      alignSelf: 'stretch',
      position: 'relative',
      overflow: 'hidden',
      aspectRatio: {base: '158.50/211.67', md: '223/320'}, // Exact aspect ratio from Figma mobile
    },
    image: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    buttonWrapper: {
      display: 'flex',
      width: 'full',
      height: 'full',
      position: 'absolute',
      top: 0,
      left: 0,
      p: {base: 3.5, md: 5}, // 14px mobile, 20px desktop
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      zIndex: 1,
    },
    button: {
      display: 'flex',
      width: {base: 7.5, md: 11.75}, // 30px mobile, 47px desktop
      height: {base: 7.5, md: 11.75}, // 30px mobile, 47px desktop
      p: {base: '8px', md: '12px 11px 11px 12px'}, // 8px mobile, varied desktop
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      borderRadius: '1000px', // Full circle
      bg: 'linear-gradient(0deg, rgba(27, 26, 24, 0.20) 0%, rgba(27, 26, 24, 0.20) 100%), rgba(255, 255, 255, 0.10)',
      backdropFilter: 'blur(15px)',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'linear-gradient(0deg, rgba(27, 26, 24, 0.30) 0%, rgba(27, 26, 24, 0.30) 100%), rgba(255, 255, 255, 0.15)',
        transform: 'scale(1.05)',
      },
      _active: {
        transform: 'scale(0.95)',
      },
    },
    buttonIcon: {
      width: {base: 3.5, md: 6}, // 14px mobile, 24px desktop
      height: {base: 3.5, md: 6}, // 14px mobile, 24px desktop
      color: 'white',
      flexShrink: 0,
    },
    tileTitle: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'heading',
      fontSize: {base: 'sm', md: 'xl'}, // 14px mobile, 20px desktop
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '120%', // 16.8px mobile, 24px desktop
    },
  },
};

export default ImageTiles;
